import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { getUnassignedTeams } from '../../../../reduxToolkit/channelSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Result } from 'antd';

const WebChat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentBrand, featureFlags } = useSelector((state) => state.app);

  useEffect(() => {
    if (!featureFlags.webchat_feature) return;
    dispatch(getUnassignedTeams({ brand_id: currentBrand?.brand_id }));
  }, []);

  if (!featureFlags?.webchat_feature) {
    return (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button
            onClick={() => {
              navigate('/user/home');
            }}
            type="primary"
          >
            Back Home
          </Button>
        }
      />
    );
  }

  return <Outlet />;
};

export default WebChat;
